/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-02 17:59:58
 * @modify date 2020-04-02 17:59:58
 * @desc [description]
 */
export const addCompany = '/admin/app/company/create';
export const companyList = '/admin/app/company/list';
export const addProject = '/admin/app/project/create';
export const projectList = '/admin/app/project/list';
export const addProduct = '/admin/app/product/create';
export const productList = '/admin/app/product/list';
export const exportAudit = '/admin/custom/export-audit-entry';
